import { gql } from '@apollo/client'

export const PRODUCT = gql`
  fragment product on  product_Entry {
    id
    title
    price
    priceLabel
    text
    linkTitle
    ctaUrl {
      type
      uri
      url
    }
  }
`;
